import { css } from '@emotion/react';
import React from 'react';

type MaptiveColorPickerCirclePointerProps = Readonly<{
  top: number;
  left: number;
  color: string;
}>;

const wrapperStyle = ({ top, left }: { top: number; left: number }) => css({
  position: 'absolute',
  top,
  left,
});

const pointerStyle = (color: string) => css({
  width: 4,
  height: 4,
  transform: 'translate(-2px, -2px)',
  boxShadow: 'rgb(255 255 255) 0px 0px 0px 1.5px, rgb(0 0 0 / 30%) 0px 0px 1px 1px inset, rgb(0 0 0 / 40%) 0px 0px 1px 2px',
  borderRadius: '50%',
  backgroundColor: color,
});

export const MaptiveColorPickerCirclePointerComponent = ({ top, left, color }: MaptiveColorPickerCirclePointerProps) => {
  return (
    <div css={wrapperStyle({ top, left })}>
      <div css={pointerStyle(color)} />
    </div>
  );
};
